import React from 'react';
import { MuiButton, MuiGrid, MuiBox, MuiTypography, MuiDivider } from 'theme/material-ui';
import { Svg } from 'components/UI/Svg';
import { Color } from 'shared/src/modules/styles/colors';
import { FontSize, Spacing } from 'shared/src/modules/styles/variables';
import useNavigationAnalytics from 'hooks/useNavigationAnalytics';
import { AnalyticsEvent } from 'services/AnalyticsService';
import { history } from 'lib/history';

const ServicesSection = () => {
  const covidTestGetStartedClicked = useNavigationAnalytics(
    AnalyticsEvent.CovidTestGetStartedClicked
  );

  const handleRequestCovidTestClick = () => {
    covidTestGetStartedClicked({ title: 'Get Care' });
    history.push('/u/get-care-now/covid-screen/patient-select');
  };

  const services = [
    {
      label: 'Request Covid-19 Test',
      startIcon: <Svg set="assets" name="COVID19" />,
      endIcon: <Svg color={Color.white} set="material" name="chevron-right" />,
      onClick: handleRequestCovidTestClick
    }
  ];

  if (services.length === 0) return null;

  return (
    <MuiGrid xs={12}>
      <MuiBox my={3}>
        <MuiTypography gutterBottom variant="h5">
          Services
        </MuiTypography>
        <MuiDivider />
      </MuiBox>
      {services.map(({ label, startIcon, endIcon, onClick }) => (
        <MuiButton
          key={label}
          variant="contained"
          size="large"
          color="primary"
          fullWidth
          disableElevation
          style={{
            justifyContent: 'space-between',
            fill: Color.white,
            fontSize: FontSize.large,
            paddingTop: Spacing.mediumLarge,
            paddingBottom: Spacing.mediumLarge
          }}
          startIcon={startIcon || null}
          endIcon={endIcon || null}
          onClick={onClick || null}
        >
          <MuiGrid component="span" container alignItems="center">
            {label}
          </MuiGrid>
        </MuiButton>
      ))}
    </MuiGrid>
  );
};

export default ServicesSection;
